import { render, staticRenderFns } from "./ficha-turno-2.vue?vue&type=template&id=6a057f27"
import script from "./ficha-turno-2.vue?vue&type=script&lang=js"
export * from "./ficha-turno-2.vue?vue&type=script&lang=js"
import style0 from "./ficha-turno-2.vue?vue&type=style&index=0&id=6a057f27&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports